import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  AlertService,
  DialogType,
} from "../../../../../services/alert.service";
import { Router } from "@angular/router";
import { ImportCsvService } from "../../../../../shared/import-dialog/services/import-csv.service";
import { BasePaginationComponent } from "../../../../../shared/base-pagination-component";
import {
  AppNotificationClient,
  AppNotificationDto,
  GetAppNotificationsResponseModel,
} from "../../../../../api/api";
import { NavigationService } from "../../../../../services/navigation.service";

@Component({
  selector: "app-notification-management",
  templateUrl: "./notification-management.component.html",
  styleUrls: ["./notification-management.component.css"],
})
export class NotificationManagementComponent
  extends BasePaginationComponent
  implements OnInit
{
  @Output() refreshData = new EventEmitter();
  @Input() title = "Notifications";
  @Input() rows: AppNotificationDto[] = [];

  currentDate = new Date();

  constructor(
    alertService: AlertService,
    private router: Router,
    private csvService: ImportCsvService,
    protected navigation: NavigationService,
    private notificationClient: AppNotificationClient,
  ) {
    super(alertService);
  }

  ngOnInit() {
    this.page = 1;
    this.getData();
  }

  override getData(): void {
    this.alertService.startLoadingMessage();
    this.notificationClient
      .appNotification_GetAppNotifications(
        undefined,
        this.search,
        this.isDescending,
        this.page,
        this.pageSize,
        this.sort,
      )
      .subscribe((results) => this.onDataLoadSuccessful(results));
  }

  onDataLoadSuccessful(result: GetAppNotificationsResponseModel) {
    this.alertService.stopLoadingMessage();

    this.rows = result.data as AppNotificationDto[];
    this.totalPage = result.count ?? 0;
  }

  markAllRead() {
    // this.notificationClient.notification_ReadAllUnReadNotification().subscribe(p => {
    //     this.rows.forEach(p => p.isRead = true);
    // });
  }

  /** Icon + colour per type; the label comes from the shared `notificationType` pipe. */
  typeInfo(type?: number): NotificationTypeInfo {
    return (
      NOTIFICATION_TYPE_INFO[type ?? -1] ?? {
        icon: "ph-bell",
        tone: "bg-b50 text-b300",
      }
    );
  }
}

/** Mirrors Common/Enums/RequestStatus.cs AppNotificationType on the backend (used for navigation). */
export enum AppNotificationType {
  AtmError = 0,
  TicketCreate = 1,
  TicketAssign = 2,
  TicketCommentCreate = 3,
  TicketResolved = 4,
  AtmNotesLow = 5,
  WithdrawalRequestApproved = 6,
  WithdrawalRequestRejected = 7,
  WithdrawalRequestCancelled = 8,
  AtmCassetteStopped = 9,
}

export interface NotificationTypeInfo {
  icon: string;
  /** Tailwind background + text classes for the icon badge. */
  tone: string;
}

export const NOTIFICATION_TYPE_INFO: { [type: number]: NotificationTypeInfo } = {
  [AppNotificationType.AtmError]: { icon: "ph-warning-octagon", tone: "bg-r50 text-r300" },
  [AppNotificationType.TicketCreate]: { icon: "ph-ticket", tone: "bg-b50 text-b300" },
  [AppNotificationType.TicketAssign]: { icon: "ph-user-plus", tone: "bg-b50 text-b300" },
  [AppNotificationType.TicketCommentCreate]: { icon: "ph-chat-dots", tone: "bg-b50 text-b300" },
  [AppNotificationType.TicketResolved]: { icon: "ph-check-circle", tone: "bg-g50 text-g400" },
  [AppNotificationType.AtmNotesLow]: { icon: "ph-money", tone: "bg-y50 text-y400" },
  [AppNotificationType.WithdrawalRequestApproved]: { icon: "ph-check-circle", tone: "bg-g50 text-g400" },
  [AppNotificationType.WithdrawalRequestRejected]: { icon: "ph-x-circle", tone: "bg-r50 text-r300" },
  [AppNotificationType.WithdrawalRequestCancelled]: { icon: "ph-prohibit", tone: "bg-n20 text-n500" },
  [AppNotificationType.AtmCassetteStopped]: { icon: "ph-stop-circle", tone: "bg-r50 text-r300" },
};
